;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { CanaryClient } from '@qogita/deprecated-canary-client'

import { SELLERS_CANARY_APPLICATION } from '../../canary-application'

/**
 * A client for the Canary API that is used to fetch data from the client.
 *
 * Fetches via the api gateway
 */
export const browserCanaryClient = new CanaryClient({
  prefixUrl: '/api/gateway',
  xQogitaApplication: SELLERS_CANARY_APPLICATION,
})
